import * as React from "react";
import type { SvgIconProps } from "../types";
import { resolveA11yProps, resolveIconSize } from "../createIcon";

export function BluetoothIcon(props: SvgIconProps) {
  const { size, title, ...rest } = props;
  const { width, height } = resolveIconSize(size, 16, 16);
  const a11y = resolveA11yProps(props);

  return (
    <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" fill="none" width={width} height={height} {...rest} {...a11y}>{title ? <title>{title}</title> : null}<g transform="translate(8 7.4) scale(0.72) translate(-8 -8)"><path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.6} d="M1.333 4.667 9.333 11.333 5.333 14.667V1.333l4 3.334-8 6.666M13.43 4.333a6.27 6.27 0 0 1 1.18 3.667 6.27 6.27 0 0 1-1.18 3.667M11.333 5.905A3.67 3.67 0 0 1 12 8a3.67 3.67 0 0 1-.667 2.095" /></g></svg>
  );
}

export default BluetoothIcon;
